import { apiUri } from "../../../config";
import axios from "axios";
import { padCalendar } from "../../../util";

export const LOAD_DANDOS = 'LOAD_DANDOS';

export const LOAD_DANDO_INFO = "LOAD_DANDO_INFO";

const receivedPageOfDandOs = (dandos, page) => {
	const convertedDandOs = dandos.content.map(c => {
		c.riskAssessmentDate = padCalendar(c.riskAssessmentDate);
		return {
			companyName: c.companyName,
			riskAssessmentDate: c.riskAssessmentDate,
			ticker: c.symbol,
			id: c.id,
			dandoId: c.dandOId,
			status: c.status,
			sicCode: c.sicCode,
			cik: c.cik,
			enabled: c.enabled,
			identifier: c.identifier,
			caseFile: c.caseFile,
			market: c.market,
			indexListId: c.indexListId,
			notes: c.notes,
			firmId: c.firmId,
			lastUpdate: c.lastUpdate,
			dateAdded: c.dateAdded,
			excelURL: c.excelURL,
			pdfURL: c.pdfURL,
			dataURL: c.dataURL,
			newsURL: c.newsURL,
			s3URL: c.s3URL
		}
	}
	);
	return ({
		type: LOAD_DANDOS,
		dandos: convertedDandOs,
		totalDandOs: dandos.total,
		totalPages: dandos.totalPages,
		currentPage: page
	})
};

export const requestPageOfDandOs = (page, sortKey='', sortOrder='') => {
	let search = JSON.parse(localStorage.getItem("searchValue")) || '';
	let sortData = JSON.parse(localStorage.getItem("sortParams"));
	if (sortData && sortData.sortValue && sortData.sortOrder) {
		sortKey = sortData.sortValue;
		sortOrder = sortData.sortOrder;
	}
	return dispatch => {
		axios.get(apiUri + "/dando/admin?page=" + page + "&search=" + search + "&sortField=" + sortKey + "&order=" + sortOrder)
			.then(json => {
				dispatch(receivedPageOfDandOs(json.data, page))
			})
			.catch(err => { console.log(err) })
	}
};


export const getDandOInfoById = Id => {
  return dispatch => {
    axios
      .get(apiUri + "/dando/" + Id)
      .then(res =>{
       
        dispatch({
          type: LOAD_DANDO_INFO,
          DandOData: res.data.data
        })

      })

      .catch(err => {
        console.log(err);
      });
  };
};


// WEBPACK FOOTER //
// ./src/components/Admin/storeDandO/action.js